import { Modal, Avatar, Text, Group, ScrollArea, Stack } from "@mantine/core";

const contributors = [
  { id: '1', name: 'Furkan Atakan BOZKURT' },
  { id: '2', name: 'İsmail YAĞCI' },
  { id: '3', name: 'Görkem YILDIZ' },
];

const getInitials = (name) => {
  if (!name) return "U";
  const names = name.split(" ");
  if (names.length > 1) {
    return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

export function ContributorsModal({ isOpen, setIsOpen }) {
  return (
    <Modal
        opened={isOpen}
        onClose={() => setIsOpen(false)}
        title="Contributors"
        centered
        size="sm"
    >
        <Text size="sm" c="dimmed" mb="md">
            Special thanks to the contributors who made this project possible.
        </Text>
        <Stack gap="md">
          {contributors.map((contributor) => (
            <Group key={contributor.id}>
              <Avatar radius="xl" color="cyan">
                {getInitials(contributor.name)}
              </Avatar>
              <Text size="sm" fw={500}>{contributor.name}</Text>
            </Group>
          ))}
        </Stack>
    </Modal>
  );
}